'use client'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import type { ReactNode } from 'react'

interface EmptyStateProps {
  /** Icon or illustration shown above the title. */
  icon?: ReactNode
  title: string
  description?: string
  /** Call-to-action, e.g. a Button. */
  action?: ReactNode
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
}: EmptyStateProps) {
  return (
    <Stack
      spacing={1}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        py: 6,
        textAlign: 'center',
        color: 'text.secondary',
      }}
    >
      {icon}
      <Typography variant="subtitle1" color="text.primary">
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
      {action && (
        <Stack
          sx={{
            pt: 1,
          }}
        >
          {action}
        </Stack>
      )}
    </Stack>
  )
}
